module.exports = __webpack_public_path__ + "static/media/excel.0b138bea.jpg";